import React, {Component, Fragment} from 'react';
import TradeSettings from 'app/components/my_profile/trades/trade_settings';
import MyTradesPage from 'app/components/my_profile/trades/my_trades';

export default class Trades extends Component {
    render() {
        return <Fragment>
            <TradeSettings/>
            <MyTradesPage />
        </Fragment>;
    }
}
